export const FUN_STYLES = [
  { id: "urgent_2k", emoji: "😭", name: "Urgent 2K Energy", title: "Urgent 2K energy", fb: "small support", message: "Abeg, urgent 2k has turned into urgent {amount}. Things are happening, and my account is not cooperating. Help your person small. 😂🙏", bg: "linear-gradient(140deg,#F59E0B 0%,#EA580C 55%,#DC2626 100%)" },
  { id: "enu_gbe", emoji: "🗣️", name: "Ẹnu Gbẹ", title: "Ẹnu gbẹ!", fb: "small support", message: "Ẹnu gbẹ! 😂 My mouth is dry and my account is drier. Abeg, {amount} fit restore joy to this life. God bless your ministry! 🙏", bg: "linear-gradient(140deg,#14B8A6 0%,#0E7490 55%,#1E3A8A 100%)" },
  { id: "no_shame", emoji: "😂", name: "No Shame Today", title: "No shame today", message: "I have checked my account. My account has checked me back. We both agree that I need {amount}. Abeg, no judge me. 😂", bg: "linear-gradient(140deg,#FACC15 0%,#F59E0B 50%,#F97316 100%)" },
  { id: "soft_life", emoji: "👑", name: "Soft Life Appeal", title: "Fund my soft life", message: "This life is too short for unnecessary suffering. 😂 Sponsor my small enjoyment with {amount}. Soft life is a collective responsibility. 💚", bg: "linear-gradient(140deg,#10B981 0%,#0F766E 55%,#0D4736 100%)" },
  { id: "food_emergency", emoji: "🍔", name: "Food Emergency", title: "Food emergency 🍔", message: "Hunger is dealing with me in a language I don't understand. 😭 Abeg, {amount} will help me settle this matter between me and my stomach. 🍛", bg: "linear-gradient(140deg,#FB7185 0%,#E11D48 55%,#C2410C 100%)" },
  { id: "pretty_please", emoji: "🥹", name: "Pretty Please", title: "Pretty please?", message: "I wasn't planning to ask, but here we are. 🥹 Can you bless me with {amount}? I promise to remember you when I become a billionaire. 😂❤️", bg: "linear-gradient(140deg,#F9A8D4 0%,#EC4899 55%,#A855F7 100%)" },
  { id: "full_drama", emoji: "🎭", name: "Full Drama", title: "Breaking news 🚨", message: "Breaking News! 🚨 A promising Nigerian is currently {amount} away from happiness. Sources say your generosity could change everything. 😂", bg: "linear-gradient(140deg,#7C3AED 0%,#4338CA 55%,#1E1B4B 100%)" },
  { id: "surprise_me", emoji: "🎲", name: "Surprise Me", title: "Surprise!", message: "Dear destiny helper, your attention is urgently needed. 😂 The situation on ground requires {amount} and a generous heart. Abeg, do the needful. 🙏", bg: "linear-gradient(140deg,#3B82F6 0%,#4F46E5 55%,#6D28D9 100%)" },
];

const SURPRISE_EXTRAS = [
  "Dear destiny helper, your attention is urgently needed. 😂 The situation on ground requires {amount} and a generous heart. Abeg, do the needful. 🙏",
  "Good news: you have been selected as my sponsor of the day! 🎉 Bad news: it comes with {amount} responsibility. Abeg, accept the award. 😂",
  "My account balance and I are no longer on speaking terms. 😭 Abeg, {amount} fit settle our quarrel. Peace is possible. 🕊️",
  "This message was approved by my empty pocket. 😂 Kindly send {amount} my way, and may your own pocket never run dry. 🙏",
];

export function surpriseMessage(currentTpl) {
  const pool = [...FUN_STYLES.filter((s) => s.id !== "surprise_me").map((s) => ({ message: s.message, fb: s.fb })),
    ...SURPRISE_EXTRAS.map((m) => ({ message: m }))].filter((x) => x.message !== currentTpl);
  return pool[Math.floor(Math.random() * pool.length)];
}

export const AMOUNT_TOKEN = "{amount}";
export const AMOUNT_FALLBACK = "a little support";
export function fillAmount(tpl, phrase) {
  return (tpl || "").split(AMOUNT_TOKEN).join(phrase);
}

export const SIMPLE_STYLE = { id: "simple", emoji: "💬", name: "Simple Ask", title: "A small request", message: "I'd really appreciate any support you can give.", bg: "linear-gradient(140deg,#155E49 0%,#0D4736 60%,#0A382A 100%)" };

export const SIMPLE_TEMPLATES = [
  { id: "simple_little_help", emoji: "💚", name: "A Little Help", title: "A little help", message: "I'd really appreciate a little financial support. Anything you can give would mean a lot.", bg: "linear-gradient(140deg,#10B981 0%,#0F766E 60%,#0D4736 100%)" },
  { id: "simple_could_you", emoji: "🤝", name: "Could You Help?", title: "Could you help?", message: "I'm reaching out to ask for some support. I'd be grateful for any help.", bg: "linear-gradient(140deg,#0EA5E9 0%,#0F766E 60%,#134E4A 100%)" },
  { id: "simple_support", emoji: "💜", name: "Your Support Means a Lot", title: "Your support means a lot", message: "If you're able to contribute, I'd genuinely appreciate your kindness.", bg: "linear-gradient(140deg,#A78BFA 0%,#7C3AED 60%,#4C1D95 100%)" },
  { id: "simple_favour", emoji: "🌷", name: "A Small Favour", title: "A small favour", message: "I could use a little help right now. Any support would be sincerely appreciated.", bg: "linear-gradient(140deg,#F9A8D4 0%,#DB2777 60%,#831843 100%)" },
  { id: "simple_thank_you", emoji: "💚", name: "Thank You for Considering", title: "Thank you for considering", message: "I'm hoping to get some financial assistance, and I'd be grateful for whatever you can offer.", bg: "linear-gradient(140deg,#34D399 0%,#059669 60%,#064E3B 100%)" },
];

export const CARD_BGS = [
  { id: "emerald_mint", name: "Emerald", bg: "linear-gradient(140deg,#047857 0%,#0F766E 50%,#064E3B 100%)" },
  { id: "sunset", name: "Sunset", bg: "linear-gradient(140deg,#FBBF24 0%,#FB7185 50%,#9333EA 100%)" },
  { id: "royal_velvet", name: "Velvet", bg: "linear-gradient(140deg,#5B21B6 0%,#581C87 55%,#0F172A 100%)" },
  { id: "golden_luxury", name: "Gold", bg: "linear-gradient(140deg,#CA8A04 0%,#B45309 55%,#713F12 100%)" },
];

export const OCCASIONS = [
  { name: "School Fees", emoji: "🎓", message: "School fees don show face again. 😅 Abeg, support me with {amount} towards this education matter. Every little help counts. 🙏" },
  { name: "House Rent", emoji: "🏠", message: "Landlord no dey understand motivational speeches. 😂 Rent is calling, and {amount} from you would really help me out. 🙏" },
  { name: "Medical", emoji: "🩺", message: "I'm dealing with some medical bills right now. If you're able to support with {amount}, it would truly help. Thank you for caring. 🙏" },
  { name: "Naming Ceremony", emoji: "👶", message: "Our little bundle of joy has arrived! 👶🎉 We're preparing for the naming ceremony, and your {amount} support would mean a lot to us. 💚" },
  { name: "Celebration", emoji: "🎉", message: "We're celebrating something special! 🎉 Join the joy with {amount} — your support will make the day even sweeter. 💚" },
  { name: "Contribution", emoji: "🤲", message: "We are putting something together, and every contribution counts. 🙏 Can you support with {amount}? We really appreciate it. 💚" },
  { name: "Graduation", emoji: "🎓", message: "Finally! The long road is over and graduation is here. 🎓 Help me celebrate this milestone with {amount}. Thank you for being part of the journey. 💚" },
  { name: "Birthday", emoji: "🎂", message: "It's my birthday! 🎂 Another year, more blessings. If you'd like to gift me {amount}, I'll be smiling all week. 😄💚" },
  { name: "Wedding", emoji: "💍", message: "We're getting married! 💍 As we prepare for our big day, your gift of {amount} would mean so much to us. Thank you! 💚" },
  { name: "Emergency", emoji: "🚑", message: "Something urgent came up and I need some help. If you can support with {amount}, I'd be truly grateful. 🙏" },
  { name: "Just Because", emoji: "💚", message: "No big reason — just asking for a little kindness today. 💚 If you can send {amount}, it would make my day. 😊" },
];

export const THANKS_STYLES = [
  { id: "playful", emoji: "🎉", name: "Playful", hint: "Confetti & a happy dance" },
  { id: "friendly", emoji: "💗", name: "Friendly", hint: "Hearts & a warm hug" },
  { id: "formal", emoji: "🏅", name: "Formal", hint: "An elegant golden emblem" },
];

export const LEND_STYLE = { id: "lend", emoji: "🤝", bg: "linear-gradient(140deg,#0F766E 0%,#0D4736 60%,#0A382A 100%)" };

export function styleFor(ask) {
  if (ask.kind === "lend") return LEND_STYLE;
  if (ask.style === "custom") {
    const bg = CARD_BGS.find((b) => b.id === ask.card_bg) || CARD_BGS[0];
    return { id: "custom", emoji: "✨", bg: bg.bg };
  }
  return FUN_STYLES.find((s) => s.id === ask.style) || SIMPLE_TEMPLATES.find((s) => s.id === ask.style) || SIMPLE_STYLE;
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const t = document.createElement("textarea");
    t.value = text; t.setAttribute("readonly", ""); t.style.position = "fixed"; t.style.opacity = "0";
    document.body.appendChild(t); t.select();
    let ok = false;
    try { ok = document.execCommand("copy"); } catch { ok = false; }
    t.remove();
    return ok;
  }
}

export function todayLocal() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export const SUGGESTED = [1000, 2000, 5000, 10000];

export function deviceId() {
  let id = localStorage.getItem("debii_device_id");
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`).replace(/[^a-zA-Z0-9-]/g, "");
    localStorage.setItem("debii_device_id", id);
  }
  return id;
}

function store(key) {
  try { return JSON.parse(localStorage.getItem(key) || "{}"); } catch { return {}; }
}

export function saveReceipt(token, receipt) {
  const all = store("debii_ask_receipts");
  all[token] = Array.from(new Set([...(all[token] || []), receipt])).slice(-20);
  localStorage.setItem("debii_ask_receipts", JSON.stringify(all));
}

export const receiptsFor = (token) => store("debii_ask_receipts")[token] || [];

export function saveLenderToken(token, lt) {
  const all = store("debii_lend_tokens");
  all[token] = lt;
  localStorage.setItem("debii_lend_tokens", JSON.stringify(all));
}

export const lenderTokenFor = (token) => store("debii_lend_tokens")[token] || null;

export const ASK_ERRORS = {
  bank_required: "Add your collection account first.",
  too_many_open_asks: "You have 10 open Asks. Close one to start another.",
  daily_ask_limit: "You've created a lot of Asks today. Try again tomorrow.",
  ask_closed: "This Ask is closed.",
  ask_revoked: "This link has been turned off by its owner.",
  access_code_invalid: "That code isn't right. Try again.",
  too_many_attempts: "Too many tries. Please wait 15 minutes.",
  too_many_pending: "You already have contributions waiting for confirmation.",
  rate_limited: "Slow down a little and try again shortly.",
  repay_date_invalid: "Pick a repayment date from today onwards.",
  terms_locked: "These terms are locked after the lender responds.",
  free_limit_reached: "You've reached the Free plan's 5 active debts.",
  counter_unchanged: "Change the amount or date to propose new terms.",
  lender_mismatch: "Only the lender who responded can do this, from the same device.",
  own_ask: "This is your own request — share it with someone who may be able to help.",
  already_linked: "This loan is already linked to another Debii account.",
  not_recorded: "This loan can be added once the borrower confirms receiving the money.",
  invalid_link: "This link isn't valid anymore.",
  cannot_respond: "This request can't be answered right now.",
  not_accepted: "Accept the request before marking money as sent.",
  ask_not_found: "We couldn't find that Ask.",
  amount_invalid: "Please enter a valid amount.",
  amount_required: "Please enter an amount.",
  access_code_format: "Access codes are 4 digits.",
};

export function friendlyError(code) {
  if (ASK_ERRORS[code]) return ASK_ERRORS[code];
  return /^[a-z0-9_]+$/.test(code || "") ? "Something went wrong. Please try again." : code;
}

const POST_AUTH = "debii_post_auth";
export function setPostAuth(path) { sessionStorage.setItem(POST_AUTH, path); }
export function takePostAuth() {
  const p = sessionStorage.getItem(POST_AUTH);
  sessionStorage.removeItem(POST_AUTH);
  return p && p.startsWith("/") && !p.startsWith("//") ? p : null;
}
